export { SIZES as ILLUSTRATION_CALLOUT_SIZES } from '@Green-Dot-Corporation/eureka-ui-media';

export default {
    AFFIRMATIVE: 'AFFIRMATIVE',
    CAUTIONARY: 'CAUTIONARY',
    ERROR: 'ERROR',
    INFO: 'INFO',
};
